<div class="widget container p-6 versionInfo">
  <p-timeline [value]="versions">
    <ng-template #opposite let-version>
      <div class="flex flex-column">
        <span class="versionNumber">v {{ version.versionNumber }}</span>

        <span class="releaseDate">{{ convertToDate(version.releaseDate) }}</span>
      </div>
    </ng-template>
    <ng-template #content let-version>
      <span>{{ "version_descriptions." + version.detailsIndex | translate }}</span>
    </ng-template>
  </p-timeline>
</div>
